//@flow

import React, { Component } from 'react';
import TimeAgo from 'react-timeago';
import isEmpty from 'lodash/isEmpty';
// import { Button, ModalBody, Modal } from 'reactstrap';
import Rater from 'react-rater';
import makeUrl from '../../lib/makeUrl';
import TextClampWithDots from '../TextClamp/TextClampWithDots';
import { useFallbackImage } from '../../lib/utils';
import ReviewForm from './ReviewsForm';
import { scrollWindowTo, computeDistanceFromTop } from '../../lib/utils';
import config from '../../config';
import getAverage from './utils';

type Props = {
  userImageURI: string | null,
  review: Object,
  addReply: (reply: string, id: string) => void,
  deleteReview: (id: string) => void,
  deleteReply: (id: string) => void,
  openLoginModal: () => void,
  isSubmitted: boolean,
  isLoggedIn: boolean,
};

type State = { canReply: boolean };

const fallbackUserAvatar = 'https://s3.amazonaws.com/honeyguide/assets/user-fallback.png';

export default class Reviews extends Component<Props, State> {
  state = { canReply: false };

  openReviewForm = () => this.setState({ canReply: true }, () => this.scrollToReply());

  scrollToReply = () => {
    const timeInterval = 120;

    //aditional height such that the submit button of the reply becomes visible
    const additionalElemY = -200;
    const replyOffset = computeDistanceFromTop(this.reply);

    const elemY = replyOffset + additionalElemY;
    scrollWindowTo(elemY, timeInterval);
  };

  onSubmitReply = (reply: string) => this.props.addReply(reply, this.props.review.id);

  /**
   * @param  {Number} value  10
   * @param  {String} unit   minute, sec, hours...
   * @param  {String} suffix ago, from
   * @return {String} '10 minutes ago'
   */

  humanizeTime = (value: number, unit: string, suffix: string) => {
    const justReviewed = unit === 'second';

    if (justReviewed) return 'just now';

    return `${value} ${unit}${value > 1 ? 's' : ''} ${suffix}`;
  };

  render() {
    const {
      review: {
        author: { name },
        comment,
        reviewedOn,
        ratings,
        id,
        replies,
      },
      openLoginModal,
      isSubmitted,
      // deleteReply,
      // deleteReview,
      userImageURI,
      isLoggedIn,
    } = this.props;

    const { canReply } = this.state;

    const defaultAuthorName = 'Guest User';
    const authorName = name && name.length > 0 ? name : defaultAuthorName;

    return (
      <li key={id}>
        <div className="comment-reply">
          <div className="for-mobile">
            {/*<div className="u-image">
               // <a href={makeUrl.goToProfile(name, author.id)}>
              <img
                src={`${config.RESOURCE_URL}/${avatar}` || ''}
                alt={name}
                onError={e => useFallbackImage(e, fallbackUserAvatar)}
              />
              // </a> 
            </div>*/}
            <div className="d-block d-sm-none">
              <h4 className="user mb-0 pb-0">{authorName}</h4>
              {ratings && (
                <Rater total={5} rating={getAverage(ratings)} interactive={false} />
              )}
            </div>
          </div>
          <div className="text-wrap">
            {/* <a href={makeUrl.goToProfile(name, author.id)}> */}
            <div className="d-none d-sm-block">
              <h4 className="user mb-0">{authorName}</h4>
              {ratings && (
                <Rater total={5} rating={getAverage(ratings)} interactive={false} />
              )}
            </div>
            {/* </a> */}
            <TextClampWithDots className="text-comment" text={comment} />
            <div className="act-btn-wrap">
              <ul>
                <li>
                  <TimeAgo date={reviewedOn} minPeriod={60} formatter={this.humanizeTime} />
                </li>
                {isLoggedIn && (
                  <li>
                    <a onClick={this.openReviewForm}>Reply</a>
                  </li>
                )}
                {/* {this.renderDeleteButton(author.id, review.id, deleteReview)} */}
              </ul>
            </div>

            {!isEmpty(replies) &&
              replies.map(({ id, comment, author, reviewedOn }) => {
                // const replyId = id;
                const { name, avatar } = author;
                const replyHasAuthor = Boolean(author);
                if (replyHasAuthor)
                  return (
                    <div className="comment-reply" key={id}>
                      <div className="u-image">
                        <a href={makeUrl.goToProfile(name, author.id)}>
                          <img
                            src={`${config.RESOURCE_URL}/${avatar}` || ''}
                            onError={e => useFallbackImage(e, fallbackUserAvatar)}
                            alt={name}
                          />
                        </a>
                      </div>
                      <div className="text-wrap">
                        <a href={makeUrl.goToProfile(name, author.id)}>
                          <h4 className="user">{name}</h4>
                        </a>
                        <TextClampWithDots className="text-comment" text={comment} />
                        <div className="act-btn-wrap">
                          <ul>
                            <li>
                              <TimeAgo
                                date={reviewedOn}
                                minPeriod={60}
                                formatter={this.humanizeTime}
                              />
                            </li>
                            {/* <li>
                          <i className="icon icon-hg-heart" /> 104 Likes
                        </li> */}
                            {/* <li> */}
                            {/* <i className="icon icon-hg-speech-bubbles" /> */}
                            {/* Reply */}
                            {/* </li> */}
                            {/* {this.renderDeleteButton(author.id, replyId, deleteReply)} */}
                          </ul>
                        </div>
                      </div>
                    </div>
                  );
                return null;
              })}
            <div
              ref={div => {
                this.reply = div;
              }}
            >
              {canReply && (
                <ReviewForm
                  addReview={this.onSubmitReply}
                  openLoginModal={openLoginModal}
                  isSubmitted={isSubmitted}
                  userImageURI={userImageURI}
                  isLoggedIn={isLoggedIn}
                />
              )}
            </div>
          </div>
        </div>
      </li>
    );
  }
}

// type DeleteButtonProps = { onDelete: id => id, id: string, onUpdated: boolean };
// type DeleteButtonState = { modal: boolean };

// class DeleteButton extends Component<DeleteButtonProps, DeleteButtonState> {
//   state = { modal: false };

//   handleDelete = () => this.props.onDelete(this.props.id);

//   onToggle = () => this.setState({ modal: !this.state.modal });

//   componentDidUpdate() {
//     const { modal } = this.state;
//     const updatedAfterDelete = modal && this.props.onUpdated;

//     if (updatedAfterDelete) this.onToggle();
//   }

//   render() {
//     return (
//       <Fragment>
//         <a onClick={this.onToggle}>Delete</a>
//         <Modal isOpen={this.state.modal} toggle={this.onToggle}>
//           <ModalBody>
//             <div>Are you sure you want to delete this review.?</div>
//           </ModalBody>
//           <Button onClick={this.handleDelete}>Delete</Button>
//           <Button onClick={this.onToggle}>Cancel</Button>
//         </Modal>{' '}
//       </Fragment>
//     );
//   }
// }

// renderDeleteButton = (authorId: string, reviewId: string, deleteFn: Function) => {
//   const userId = getUserIdFromStorage();
//   const userIsAuthorOfReview = userId === authorId;

//   if (userIsAuthorOfReview) {
//     return (
//       <li>
//         <DeleteButton
//           onDelete={deleteFn}
//           id={reviewId}
//           onUpdated={this.props.isSubmitted}
//         />
//       </li>
//     );
//   }
// };



// WEBPACK FOOTER //
// ./src/components/ReviewsRatings/Reviews.jsx